import { createContract } from "../utils/createContract";

export const callFunction = (
  addressContract: string,
  library: any,
  params: any[],
  fnToCall: string,
  abi?: any,
  callback?: any
) => {
  const contract = createContract(abi, library, addressContract);

  if (!contract) return;

  return contract[fnToCall](...params).then((response) => {
    console.debug(`${fnToCall} transaction sent successfully`);
    if (response.wait) {
      return response.wait().then((response) => {
        console.debug(`Transaction ${response.transactionHash} confirmed`);
        return callback ? callback(response) : response;
      });
    } else {
      return callback ? callback(response) : response;
    }
  });
};
